function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.002 512.002",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFF09E"
    },
    points: "351.384,16.284 347.589,16.284 347.589,122.034 464.784,122.034  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFF09E"
    },
    points: "326.576,303.218 326.576,205.512 186.309,205.512 186.309,141.13 44.669,255.999  186.309,370.87 186.309,303.218  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32976b"
    },
    d: "M467.334,202.728c-8.994,0-16.284,7.29-16.284,16.284v260.42H105.829V326.566l70.225,56.953 c2.957,2.399,6.592,3.636,10.259,3.636c2.379,0,4.773-0.521,7.002-1.584c5.668-2.702,9.279-8.42,9.279-14.7v-51.368h123.983 c8.994,0,16.284-7.29,16.284-16.284v-97.706c0-8.994-7.29-16.284-16.284-16.284H202.593v-48.1c0-6.279-3.61-12-9.279-14.7 c-5.665-2.702-12.384-1.902-17.263,2.052L34.412,243.353c-3.812,3.091-6.027,7.738-6.027,12.648c0,4.91,2.215,9.555,6.027,12.648 l38.847,31.505v195.564c0,8.994,7.29,16.284,16.284,16.284h377.789c8.994,0,16.284-7.29,16.284-16.284V219.012 C483.618,210.018,476.327,202.728,467.334,202.728z M170.027,175.302v30.208c0,8.994,7.29,16.284,16.284,16.284h123.983v65.138 H186.311c-8.994,0-16.284,7.29-16.284,16.284v33.48l-99.503-80.697L170.027,175.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32976b"
    },
    d: "M89.545,138.318c8.994,0,16.284-7.29,16.284-16.284V32.568h225.476v89.466 c0,8.994,7.29,16.284,16.284,16.284h117.194c6.689,0,12.698-4.092,15.151-10.316c2.452-6.224,0.848-13.315-4.045-17.878 L362.491,4.376c-0.124-0.116-0.259-0.217-0.386-0.327c-0.192-0.168-0.383-0.335-0.583-0.493c-0.2-0.16-0.405-0.309-0.612-0.458 c-0.217-0.156-0.432-0.311-0.656-0.458c-0.199-0.129-0.402-0.248-0.606-0.368c-0.246-0.147-0.493-0.29-0.747-0.423 c-0.191-0.099-0.386-0.187-0.58-0.28c-0.275-0.13-0.55-0.261-0.835-0.375c-0.189-0.077-0.383-0.14-0.575-0.21 c-0.295-0.106-0.588-0.213-0.889-0.303c-0.207-0.062-0.417-0.107-0.625-0.161c-0.292-0.073-0.58-0.153-0.878-0.21 c-0.267-0.052-0.537-0.085-0.806-0.124c-0.246-0.034-0.489-0.081-0.738-0.104C352.448,0.029,351.918,0,351.384,0h-3.794H89.545 c-8.994,0-16.284,7.29-16.284,16.284v105.75C73.261,131.028,80.551,138.318,89.545,138.318z M363.873,105.75V50.197l59.572,55.553 H363.873z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.2f7657fa6620a1efe6307676beee9e2a.svg";
export { ForwardRef as ReactComponent };